// REACT
import React, { useState, useRef } from "react";

// IONIC
import {
  IonSegment,
  IonSegmentButton,
  IonRow,
  IonCol,
  IonGrid,
  IonSlides,
  IonSlide,
  IonText,
} from "@ionic/react";

//import Segment from '../components/Segment';
function TabEntsorgung(props) {
  // a ref variable to handle the current slider
  const slider = useRef();
  // a state value to bind segment value
  const [value, setValue] = useState("0");

  const slideOpts = {
    initialSlide: 0,
    speed: 400,
    loop: false,
    pagination: {
      el: null,
    },
  };

  // a function to handle the segment changes
  const handleSegmentChange = async (e) => {
    setValue(e.detail.value);
    slider.current.slideTo(e.detail.value);
  };

  // a function to handle the slider changes
  const handleSlideChange = async (e) => {
    let index = 0;
    await e.target.getActiveIndex().then((value) => {
      index = value;
      let ionSlide = document.querySelector("ion-slide.swiper-slide-active");
      slider.current.style.height = ionSlide.clientHeight.toString() + "px";
    });
    setValue("" + index);
  };

  function decode(str) {
    let txt = document.createElement("div");
    txt.innerHTML = str;
    var realtext = txt.innerText.replaceAll("&nbsp;", "\u00A0");
    return realtext;
  }

  return (
    <>
      {/*-- Segment in a toolbar --*/}
      {/*-- the value is binded to state value and is updated every time setValue is running --*/}
      {/*-- buttons values are set to 0 and 1, to match slider index, it can be whatever you need but there mas be a table --*/}
      <IonSegment
        color="secondary"
        value={value}
        onIonChange={(e) => handleSegmentChange(e)}
        className="segment__entsorgung"
      >
        <IonSegmentButton value="0">
          <IonText>Informationen</IonText>
        </IonSegmentButton>
      </IonSegment>

      {/*-- Market Segment --*/}
      {/*-- the ref method binds this slider to slider variable --*/}
      <IonSlides
        pager={true}
        options={slideOpts}
        onIonSlideDidChange={(e) => handleSlideChange(e)}
        ref={slider}
      >
        <IonSlide className="ion-text-start">
          <IonGrid>
            <IonRow>
              {props.url === "" ? (
                <IonCol
                  className="pitch__background__image "
                  size="12"
                  size-sm="6"
                  style={{
                    background: "url('/wp-content/uploads/2023/07/230620_Dolde_Schild_Muster_378x200px.jpg') no-repeat center",
                  }}
                ></IonCol>
              ) : (
                <IonCol
                  className="pitch__background__image "
                  size="12"
                  size-sm="6"
                  style={{
                    background: `url('${props.url}') no-repeat center`,
                  }}
                ></IonCol>
              )}
              <IonCol size="12" size-sm="6" className="ion-padding-start">
                <table className="tab__table">
                  {props.entsorgungsstation.features.length !== 0 &&
                    props.entsorgungsstation.features.feature.map((item) => {
                      if (item.symbol === "l" || item.symbol === "k") {
                        return (
                          <>
                            <tr>
                              <td
                                className={`font__icon infocard__icon_entsorgung tab__table__left ${item.symbol}`}
                              >
                                {item.symbol}
                              </td>
                              <td className="tab__table__right">
                                {" "}
                                <p>{item.anmerkung}</p>
                              </td>
                            </tr>
                          </>
                        );
                      }
                    })}
                  {props.entsorgungsstation.system.length !== 0 && (
                    <>
                      <p>System: {props.entsorgungsstation.system}</p>
                    </>
                  )}{" "}
                  {props.entsorgungsstation.durchreise.length !== 0 && (
                    <p>{props.entsorgungsstation.durchreise}</p>
                  )}
                </table>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonSlide>
      </IonSlides>
    </>
  );
}

export default TabEntsorgung;
